// extracted by mini-css-extract-plugin
export var option = "_bb-0";
export var optionCard = "_bb-f";
export var optionContent = "_bb-g";
export var optionIcon = "_bb-i";
export var optionIconBox = "_bb-h";
export var optionLabel = "_bb-j";
export var optionPill = "_bb-m";
export var optionPillBadge = "_bb-p";
export var optionPillIcon = "_bb-n";
export var optionPillLabel = "_bb-o";
export var optionRadio = "_bb-k";
export var optionRadioInner = "_bb-l";
export var optionReveal = "_bb-2";
export var optionRevealDelay0 = "_bb-3";
export var optionRevealDelay1 = "_bb-4";
export var optionRevealDelay10 = "_bb-d";
export var optionRevealDelay11 = "_bb-e";
export var optionRevealDelay2 = "_bb-5";
export var optionRevealDelay3 = "_bb-6";
export var optionRevealDelay4 = "_bb-7";
export var optionRevealDelay5 = "_bb-8";
export var optionRevealDelay6 = "_bb-9";
export var optionRevealDelay7 = "_bb-a";
export var optionRevealDelay8 = "_bb-b";
export var optionRevealDelay9 = "_bb-c";
export var optionSelected = "_bb-1";